import { render, staticRenderFns } from "./embed-form.vue?vue&type=template&id=f752dd8c&scoped=true"
import script from "./embed-form.vue?vue&type=script&lang=js"
export * from "./embed-form.vue?vue&type=script&lang=js"
import style0 from "./embed-form.vue?vue&type=style&index=0&id=f752dd8c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f752dd8c",
  null
  
)

export default component.exports